import React, { useEffect, useRef } from 'react';
import 'bulma/css/bulma.min.css';

const TopNotification = ({
  title,
  message,
  type = 'is-warning',
  duration = 5000,
  onClose,
  onAction,
  actionLabel = 'Show',
}) => {
  const closeRef = useRef(onClose);

  useEffect(() => {
    closeRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (duration == null) {
      return undefined;
    }

    const timer = setTimeout(() => {
      closeRef.current?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <div
      className={`notification ${type}`}
      style={{ marginBottom: '0.5rem', position: 'relative' }}
    >
      <button
        className="delete"
        onClick={onClose}
        style={{ position: 'absolute', top: '0.5rem', right: '0.5rem' }}
      ></button>
      {title && <p className="title is-6">{title}</p>}
      <div className="is-flex is-align-items-center">
        <span className="has-text-weight-medium">{message}</span>
        {onAction && (
          <button
            className={`button is-small ${type} is-light`}
            style={{ marginLeft: '0.5rem' }}
            onClick={onAction}
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default TopNotification;